<div class="content-card">
  <button class="btn btn-primary" (click)="downloadGlobal()">
    Download Global Datacenter Report
  </button>
</div>
